export default __webpack_public_path__ + "static/media/kliznekapije5.a36bb623.png";